import { useState, useEffect } from 'react';
import { HealthMetrics } from '../types/health';
import { simulateHealthMetrics } from '../utils/simulation';

export function useHealthMetrics() {
  const [metrics, setMetrics] = useState<HealthMetrics>(simulateHealthMetrics());

  useEffect(() => {
    const interval = setInterval(() => {
      setMetrics(prev => ({
        ...prev,
        steps: {
          ...prev.steps,
          current: prev.steps.current + Math.floor(Math.random() * 100)
        },
        calories: {
          ...prev.calories,
          current: prev.calories.current + Math.floor(Math.random() * 20)
        },
        heartRate: {
          ...prev.heartRate,
          current: Math.floor(Math.random() * 21) + 65,
          history: [...prev.heartRate.history.slice(1), Math.floor(Math.random() * 21) + 65]
        }
      }));
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return metrics;
}